// src/firebase.js
import { initializeApp } from 'firebase/app';
import { doc, getFirestore } from 'firebase/firestore';
//'firebase/firestore/lite'
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

export const CONTACTS_COLLECTION = 'contacts';
export const CLIENT_CONTACT_RELATIONSHIPS_COLLECTION = 'contactClientRelationships';
export const DEAL_CONTACT_RELATIONSHIPS_COLLECTION = 'contactDealRelationships';
export const CLIENTS_COLLECTION = 'clients';
export const BROKER_GROUP_COLLECTION = 'brokerGroup';
export const ENGAGE_SHARE_LINKS_COLLECTION = 'engageShareLinks';

// const firebaseConfig = {
//   projectId: "folio-app-3cd6d",
//   storageBucket: "gs://folio-app-3cd6d.appspot.com",
// };
const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export const toBrokerGroupRefs = (brokerGroupIds) =>
	(brokerGroupIds ?? [])
		.filter(Boolean)
		.map((id) => doc(firestore, BROKER_GROUP_COLLECTION, id));

export { storage, firestore, auth, app as firebase };
